import React, { useState, useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import {
    updateSetting,
    getLeadStatusesWithPagination,
    getConfigurationStatusesWithPagination,
    addLeadStatus,
    addConfigurationStatus,
    updateLeadStatus,
    updateConfigurationStatus,
    deleteLeadStatus,
    deleteConfigurationStatus,
    getSetting,
    addWhatsAppMessage,
    getWhatsAppMessage,
    updateWhatsAppMessage,
    deleteWhatsAppMessage,
    addLeadFrom,
    updateLeadFrom,
    deleteLeadFrom,
    getLeadFrom,
    manageAutoAssign,
    getEmailTemplates,
    addEmailTemplate,
    updateEmailTemplate,
    deleteEmailTemplate,
    fetchAllEmailTemplates
} from '../../../redux/actions/Setting.action';
import { allCounselorDetail } from '../../../redux/actions/Files.action';
import { toast } from "react-toastify";
import ReactPaginate from 'react-paginate';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
    Switch,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { useRef } from 'react';


export default function Setting() {
    const dispatch = useDispatch();
    const [accessToken, setAccessToken] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedLeadStatus, setSelectedLeadStatus] = useState(null);
    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [configurationPage, setConfigurationPage] = useState(1);
    const [configurationRowsPerPage, setConfigurationRowsPerPage] = useState(10);
    const [showConfigurationModal, setShowConfigurationModal] = useState(false);
    const [isEditingConfiguration, setIsEditingConfiguration] = useState(false);
    const [selectedConfigurationStatus, setSelectedConfigurationStatus] = useState(null);

    const [whatsappMessages, setWhatsappMessages] = useState([]);
    const [showWhatsappModal, setShowWhatsappModal] = useState(false);
    const [isEditingWhatsapp, setIsEditingWhatsapp] = useState(false);
    const [selectedWhatsappMessage, setSelectedWhatsappMessage] = useState(null);
    const [whatsappPage, setWhatsappPage] = useState(1);
    const [whatsappRowsPerPage, setWhatsappRowsPerPage] = useState(10);
    const [totalWhatsappPages, setTotalWhatsappPages] = useState(1);
    // Add these new states for Lead From
    const [leadFromPage, setLeadFromPage] = useState(1);
    const [leadFromRowsPerPage, setLeadFromRowsPerPage] = useState(10);
    const [showLeadFromModal, setShowLeadFromModal] = useState(false);
    const [isEditingLeadFrom, setIsEditingLeadFrom] = useState(false);
    const [selectedLeadFrom, setSelectedLeadFrom] = useState(null);
    const [isAutoAssign, setIsAutoAssign] = useState(false);
    const [showDeleteLeadFromModal, setShowDeleteLeadFromModal] = useState(false);
    const [leadFromToDelete, setLeadFromToDelete] = useState(null);
    const { leadStatuses, totalPages, configurationStatuses, configurationTotalPages, getAllWhatsAppMessage, } = useSelector((state) => state.setting);
    const getAllEmailTemplates = useSelector(state => state.setting.getAllEmailTemplates);
    const getSettings = useSelector((state) => state.setting);
    const counselorData = useSelector((state) => state.files);
    const managers = counselorData?.allCounselor?.data?.CounselorsData;

    const [emailTemplates, setEmailTemplates] = useState([]);
    const [emailPage, setEmailPage] = useState(1);
    const [emailRowsPerPage, setEmailRowsPerPage] = useState(10);
    const [totalEmailPages, setTotalEmailPages] = useState(1);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [isEditingEmail, setIsEditingEmail] = useState(false);
    const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
    const emailRef = useRef(null);
    const whatsappRef = useRef(null);
    const leadFromRef = useRef(null);
    const leadStatusRef = useRef(null);
    const configurationStatusRef = useRef(null);


    useEffect(() => {
        dispatch(getSetting());
        dispatch(allCounselorDetail());
    }, []);

    useEffect(() => {
        dispatch(getLeadStatusesWithPagination(mainPage, rowsPerPage));
    }, [dispatch, mainPage, rowsPerPage]);
    useEffect(() => {
        dispatch(getConfigurationStatusesWithPagination(configurationPage, configurationRowsPerPage));
    }, [dispatch, configurationPage, configurationRowsPerPage]);
    const scrollToSection = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const refreshEmailTemplates = () => {
        dispatch(fetchAllEmailTemplates())
            .catch((err) => {
                toast.error("Failed to load email templates");
                console.error("Fetch error:", err);
            });
    };

    // Load templates on first render
    useEffect(() => {
        refreshEmailTemplates();
    }, [dispatch]);

    // Add this new useEffect to fetch WhatsApp messages
    useEffect(() => {
        dispatch(getWhatsAppMessage(whatsappPage, whatsappRowsPerPage))
            .then((res) => {
                setWhatsappMessages(res?.data || []);
                setTotalWhatsappPages(res?.data?.totalPages || 1);
            });
    }, [dispatch, whatsappPage, whatsappRowsPerPage]);

    // Add this new useEffect to fetch email templates
    useEffect(() => {
        dispatch(getEmailTemplates(emailPage, emailRowsPerPage))
            .then((res) => {
                if (res?.data) {
                    setEmailTemplates(res.data || []);
                    setTotalEmailPages(res.data?.totalPages || 1);
                }
            });

    }, [dispatch, emailPage, emailRowsPerPage]);


    // Remove these lines
    // const [accessToken, setAccessToken] = useState("");

    // Remove this useEffect
    // useEffect(() => {
    //     if (getSettings?.getSetting?.leadStatuses && getSettings?.getSetting?.leadStatuses.length > 0) {
    //         setAccessToken(getSettings?.getSetting?.leadStatuses[0]?.facebookPageAccessToken);
    //     }
    // }, [getSettings]);

    // Remove handleUpdateSetting function
    // const handleUpdateSetting = () => {
    //     if (!accessToken.trim()) {
    //         toast.error("Access Token cannot be empty");
    //         return;
    //     }
    //     const payload = { facebookPageAccessToken: accessToken };
    //     dispatch(updateSetting(payload))
    //         .then(() => toast.success("Access Token updated successfully!"))
    //         .catch((error) => {
    //             toast.error("Failed to update Access Token");
    //             console.error("Update Setting Error:", error);
    //         });
    // };

    const handlePageChange = (selected) => setMainPage(selected.selected + 1);
    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
    };
    const handleConfigurationPageChange = (selected) => setConfigurationPage(selected.selected + 1);
    const handleConfigurationRowsPerPageChange = (e) => {
        setConfigurationRowsPerPage(parseInt(e.target.value, 10));
        setConfigurationPage(1);
    };

    const validationSchema = Yup.object().shape({
        title: Yup.string().required('Title is required'),
        backgroundColor: Yup.string().required('Background Color is required'),
    });

    const whatsappValidationSchema = Yup.object().shape({
        title: Yup.string().required('Title is required'),
        message: Yup.string().required('Message is required'),
    });

    // Fetch WhatsApp messages
    useEffect(() => {
        dispatch(getWhatsAppMessage(whatsappPage, whatsappRowsPerPage))
            .then((res) => {
                if (res?.status == 200) {
                    setWhatsappMessages(res?.data || []);
                    setTotalWhatsappPages(res?.data?.totalPages || 1);
                }
            })
            .catch((err) => {
                toast.error("Failed to load WhatsApp messages");
                console.error(err);
            });
    }, [dispatch, whatsappPage, whatsappRowsPerPage]);


    const handleAddOrUpdateLeadStatus = async (values, { resetForm }) => {
        try {
            if (isEditing) {
                await dispatch(updateLeadStatus(selectedLeadStatus._id, values));
            } else {
                await dispatch(addLeadStatus(values));
            }
            resetForm();
            setShowModal(false);
            dispatch(getLeadStatusesWithPagination(mainPage, rowsPerPage));
        } catch (error) {
            toast.error('Failed to process Lead Status');
        }
    };

    const handleAddOrUpdateConfigurationStatus = async (values, { resetForm }) => {
        try {
            if (isEditingConfiguration) {
                await dispatch(updateConfigurationStatus(selectedConfigurationStatus._id, values));
            } else {
                await dispatch(addConfigurationStatus(values));
            }
            resetForm();
            handleCloseConfigurationModal();
            dispatch(getConfigurationStatusesWithPagination(configurationPage, configurationRowsPerPage));
        } catch (error) {
            toast.error('Failed to process Voice AI Status');
        }
    };

    const openEditModal = (status) => {
        setSelectedLeadStatus(status);
        setIsEditing(true);
        setShowModal(true);
    };

    const openConfigurationEditModal = (status) => {
        setSelectedConfigurationStatus(status);
        setIsEditingConfiguration(true);
        setShowConfigurationModal(true);
    };

    const handleDeleteLeadStatus = (id) => {
        if (window.confirm("Are you sure you want to delete this lead status?")) {
            dispatch(deleteLeadStatus(id))
                .then(() => dispatch(getLeadStatusesWithPagination(mainPage, rowsPerPage)))
                .catch((error) => {
                    toast.error("Failed to delete lead status");
                    console.error("Delete Lead Status Error:", error);
                });
        }
    };

    const handleDeleteConfigurationStatus = (id) => {
        if (window.confirm("Are you sure you want to delete this Voice AI status?")) {
            dispatch(deleteConfigurationStatus(id))
                .then(() => dispatch(getConfigurationStatusesWithPagination(configurationPage, configurationRowsPerPage)))
                .catch((error) => {
                    toast.error("Failed to delete Voice AI status");
                    console.error("Delete Voice AI Status Error:", error);
                });
        }
    };

    const handleCloseConfigurationModal = () => {
        setShowConfigurationModal(false);
        setIsEditingConfiguration(false);
        setSelectedConfigurationStatus(null);
    };

    const handleAddOrUpdateWhatsapp = async (values, { resetForm }) => {
        try {
            if (isEditingWhatsapp) {
                const payload = {
                    title: values.title,
                    description: values.message
                };
                await dispatch(updateWhatsAppMessage(selectedWhatsappMessage._id, payload));
            } else {
                const payload = {
                    title: values.title,
                    description: values.message
                };
                await dispatch(addWhatsAppMessage(payload));
            }

            // Refresh list
            dispatch(getWhatsAppMessage(whatsappPage, whatsappRowsPerPage))
                .then((res) => {
                    setWhatsappMessages(res?.data || []);
                    setTotalWhatsappPages(res?.data?.totalPages || 1);
                });

            resetForm();
            setShowWhatsappModal(false);
            setIsEditingWhatsapp(false);
            setSelectedWhatsappMessage(null);
        } catch (error) {
            toast.error("Failed to save WhatsApp message");
            console.error("Save WhatsApp Message Error:", error);
        }
    };


    const handleWhatsappPageChange = (selected) => {
        setWhatsappPage(selected.selected + 1);
    };

    const handleWhatsappRowsChange = (e) => {
        setWhatsappRowsPerPage(Number(e.target.value));
        setWhatsappPage(1);
    };

    const handleDeleteWhatsappMessage = (id) => {
        if (window.confirm("Are you sure you want to delete this WhatsApp message?")) {
            dispatch(deleteWhatsAppMessage(id))
                .then(() => {
                    toast.success("Message deleted");
                    dispatch(getWhatsAppMessage(whatsappPage, whatsappRowsPerPage))
                        .then(res => {
                            setWhatsappMessages(res?.data || []);
                            setTotalWhatsappPages(res?.data?.totalPages || 1);
                        });
                })
                .catch((err) => {
                    toast.error("Failed to delete WhatsApp message");
                    console.error("Delete error:", err);
                });
        }
    };
    // Yup schema for Email validation
    const emailValidationSchema = Yup.object().shape({
        title: Yup.string().required('Title is required'),
        message: Yup.string().required('Message is required'),
    });

    // Fetch Email Templates
    useEffect(() => {
        dispatch(getEmailTemplates(emailPage, emailRowsPerPage))
            .then((res) => {
                if (res?.data) {
                    setEmailTemplates(res.data || []);
                    setTotalEmailPages(res.data?.totalPages || 1);
                }
            })

            .catch((err) => {
                toast.error("Failed to load email templates");
                console.error(err);
            });
    }, [dispatch, emailPage, emailRowsPerPage]);


    const handleAddOrUpdateEmail = async (values, { resetForm }) => {
        try {
            const payload = {
                title: values.title,
                description: values.message,
            };

            if (isEditingEmail) {
                await dispatch(updateEmailTemplate(selectedEmailTemplate._id, payload));
            } else {
                await dispatch(addEmailTemplate(payload));
            }
            refreshEmailTemplates(); // Refresh after add/update

            resetForm();
            setShowEmailModal(false);
            setIsEditingEmail(false);
            setSelectedEmailTemplate(null);
        } catch (error) {
            toast.error("Failed to save email template");
            console.error("Save Email Template Error:", error);
        }
    };

    const handleEmailPageChange = (selected) => {
        setEmailPage(selected.selected + 1);
    };

    const handleEmailRowsChange = (e) => {
        setEmailRowsPerPage(Number(e.target.value));
        setEmailPage(1);
    };

    const handleDeleteEmailTemplate = (id) => {
        if (window.confirm("Are you sure you want to delete this email template?")) {
            dispatch(deleteEmailTemplate(id))
                .then(() => {
                    toast.success("Template deleted");
                    refreshEmailTemplates(); // Refresh after delete

                })
                .catch((err) => {
                    toast.error("Failed to delete email template");
                    console.error("Delete error:", err);
                });
        }
    };


    useEffect(() => {
        dispatch(getLeadFrom(leadFromPage, leadFromRowsPerPage));
    }, [dispatch, leadFromPage, leadFromRowsPerPage]);

    const leadFromValidationSchema = Yup.object().shape({
        title: Yup.string().required('Title is required'),
        leadAssignTo: Yup.string().required('Manager Assignment is required')
    });

    const handleAddOrUpdateLeadFrom = async (values, { resetForm }) => {
        try {
            if (isEditingLeadFrom) {
                await dispatch(updateLeadFrom(selectedLeadFrom._id, values));
            } else {
                await dispatch(addLeadFrom(values));
            }
            resetForm();
            setShowLeadFromModal(false);
            dispatch(getLeadFrom(leadFromPage, leadFromRowsPerPage));
        } catch (error) {
            toast.error('Failed to process Lead From');
        }
    };

    const handleDeleteLeadFrom = (id) => {
        setLeadFromToDelete(id);
        setShowDeleteLeadFromModal(true);
    };

    const confirmDeleteLeadFrom = () => {
        dispatch(deleteLeadFrom(leadFromToDelete))
            .then(() => {
                dispatch(getLeadFrom(leadFromPage, leadFromRowsPerPage));
                setShowDeleteLeadFromModal(false);
                toast.success("Lead From deleted successfully");
            })
            .catch((error) => {
                toast.error("Failed to delete lead from");
                console.error("Delete Lead From Error:", error);
            });
    };

    const handleLeadFromPageChange = (selected) => {
        setLeadFromPage(selected.selected + 1);
    };

    const handleLeadFromRowsChange = (e) => {
        setLeadFromRowsPerPage(Number(e.target.value));
        setLeadFromPage(1);
    };

    useEffect(() => {
        if (getSettings?.getLeadFroms?.isAutoAssign !== undefined) {
            setIsAutoAssign(getSettings?.getLeadFroms?.isAutoAssign);
        }
    }, [getSettings]);

    const handleAutoAssignToggle = async () => {
        try {
            const payload = { isAutoAssign: !isAutoAssign };
            await dispatch(manageAutoAssign(payload));
            setIsAutoAssign(!isAutoAssign);
        } catch (error) {
            console.error('Error toggling auto-assign:', error);
        }
    };
    return (
        <div className="mt-[100px]">
            {/* Remove this section
            <h4 className='font-bold'>Facebook Page Access Token</h4>
            <div className='d-flex'>
                <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2">
                    <input
                        type="text"
                        name="AccessToken"
                        className="w-full outline-none"
                        placeholder="Access Token"
                        value={accessToken}
                        onChange={(e) => setAccessToken(e.target.value)}
                    />
                </div>
                <Button className="!bg-theme-dark fw-bold d-flex align-items-center border-0" onClick={handleUpdateSetting}>
                    <IoMdAdd className="mt-1 gap-1" />
                    {getSettings?.getSetting?.leadStatuses?.[0]?.facebookPageAccessToken ? 'Update Access Token' : 'Add Access Token'}
                </Button>
            </div>
            */}
            <div className="inline-flex mb-6 border border-gray-300 rounded-md overflow-hidden">
                <button
                    onClick={() => scrollToSection(leadStatusRef)}
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none"
                >
                    Lead Statuses
                </button>
                {/* <button
                    onClick={() => scrollToSection(configurationStatusRef)}
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none border-l border-gray-300"
                >
                    Voice AI Statuses
                </button> */}
                <button
                    onClick={() => scrollToSection(whatsappRef)}
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none border-l border-gray-300"
                >
                    WhatsApp Templates
                </button>
                <button
                    onClick={() => scrollToSection(emailRef)}
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none border-l border-gray-300"
                >
                    Email Templates
                </button>
                <button
                    onClick={() => scrollToSection(leadFromRef)}
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none border-l border-gray-300"
                >
                    Lead From
                </button>
            </div>



            {/* Lead Status Section */}
            <div ref={leadStatusRef} className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between'>
                    <h3 className='fw-bold'>Lead Statuses</h3>
                    <div>
                        Rows per page:
                        <select value={rowsPerPage} onChange={handleRowsPerPageChange} className="ms-2 border rounded-md focus:outline-none">
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    <Button className="!bg-theme-dark fw-bold d-flex align-items-center border-0" onClick={() => {
                        setIsEditing(false);
                        setSelectedLeadStatus(null);
                        setShowModal(true);
                    }}>
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Lead Status
                    </Button>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Title</Th>
                                <Th>Background Color</Th>
                                <Th>Created By</Th>
                                <Th>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {leadStatuses?.length > 0 ? leadStatuses.map((status) => (
                                <Tr key={status._id}>
                                    <Td>{status.title}</Td>
                                    <Td>
                                        <div style={{ backgroundColor: status.backgroundColor, width: '30px', height: '30px', borderRadius: '50%' }}></div>
                                    </Td>
                                    <Td>{status?.createdBy?.name || '-'}</Td>
                                    <Td>
                                        <div className='d-flex gap-2 fs-6 fw-bold'>
                                            <FaEdit className='text-success' onClick={() => openEditModal(status)} />Edit
                                            <FaTrashAlt className='text-danger cursor-pointer' title="Delete" onClick={() => handleDeleteLeadStatus(status._id)} />Delete
                                        </div>
                                    </Td>
                                </Tr>
                            )) : (
                                <Tr><Td colSpan="3" className="text-center">No Lead Statuses Found</Td></Tr>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={5}
                    pageCount={totalPages || 1}
                    previousLabel="< Previous"
                    renderOnZeroPageCount={null}
                    className="pagination"
                />
            </div>

            {/* Voice AI Status Section */}
            {/* <div ref={configurationStatusRef} className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between'>
                    <h3 className='fw-bold'>Voice AI Statuses</h3>
                    <div>
                        Rows per page:
                        <select value={configurationRowsPerPage} onChange={handleConfigurationRowsPerPageChange} className="ms-2 border rounded-md focus:outline-none">
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    <Button className="!bg-theme-dark fw-bold d-flex align-items-center border-0" onClick={() => {
                        setIsEditingConfiguration(false);
                        setSelectedConfigurationStatus(null);
                        setShowConfigurationModal(true);
                    }}>
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Voice AI Status
                    </Button>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Title</Th>
                                <Th>Background Color</Th>
                                <Th>Created By</Th>
                                <Th>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {configurationStatuses?.length > 0 ? configurationStatuses.map((status) => (
                                <Tr key={status._id}>
                                    <Td>{status.title}</Td>
                                    <Td>
                                        <div style={{ backgroundColor: status.backgroundColor, width: '30px', height: '30px', borderRadius: '50%' }}></div>
                                    </Td>
                                    <Td>{status?.createdBy?.name || '-'}</Td>
                                    <Td>
                                        <div className='d-flex gap-2 fs-6 fw-bold'>
                                            <FaEdit className='text-success' onClick={() => openConfigurationEditModal(status)} />Edit
                                            <FaTrashAlt className='text-danger cursor-pointer' title="Delete" onClick={() => handleDeleteConfigurationStatus(status._id)} />Delete
                                        </div>
                                    </Td>
                                </Tr>
                            )) : (
                                <Tr><Td colSpan="4" className="text-center">No Voice AI Statuses Found</Td></Tr>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={handleConfigurationPageChange}
                    pageRangeDisplayed={5}
                    pageCount={configurationTotalPages || 1}
                    previousLabel="< Previous"
                    renderOnZeroPageCount={null}
                    className="pagination"
                />
            </div> */}
            {/* <div className="flex gap-4 mb-4">
                <button onClick={() => scrollToSection(whatsappRef)} className="px-4 py-2 bg-green-500 text-white rounded">WhatsApp Templates</button>
                <button onClick={() => scrollToSection(emailRef)} className="px-4 py-2 bg-blue-500 text-white rounded">Email Templates</button>
                <button onClick={() => scrollToSection(leadFromRef)} className="px-4 py-2 bg-purple-500 text-white rounded">Lead From</button>
            </div> */}


            {/* WhatsApp Messages Section */}
            <div ref={whatsappRef} className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between'>
                    <h3 className='fw-bold'>WhatsApp Message Templates</h3>
                    <div className="flex items-center gap-3">
                        Rows per page:
                        <select value={whatsappRowsPerPage} onChange={handleWhatsappRowsChange} className="ms-2 border rounded-md focus:outline-none">
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    <Button className="!bg-theme-dark fw-bold d-flex align-items-center border-0" onClick={() => {
                        setIsEditingWhatsapp(false);
                        setSelectedWhatsappMessage(null);
                        setShowWhatsappModal(true);
                    }}>
                        <IoMdAdd className="mt-1 gap-1" />
                        Add WhatsApp Message
                    </Button>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="green">
                        <Thead>
                            <Tr>
                                <Th>Title</Th>
                                <Th>Message</Th>
                                <Th>Created By</Th>
                                <Th>Actions</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {getAllWhatsAppMessage?.data?.length > 0 ? getAllWhatsAppMessage?.data?.map((msg) => (
                                <Tr key={msg?._id}>
                                    <Td>{msg?.title}</Td>
                                    <Td style={{
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word'
                                    }}>
                                        {msg?.description}
                                    </Td>
                                    <Td>{msg?.createdBy?.name || '-'}</Td>
                                    <Td>
                                        <div className='d-flex gap-2 fs-6 fw-bold'>
                                            <FaEdit
                                                className='text-success'
                                                onClick={() => {
                                                    setIsEditingWhatsapp(true);
                                                    setSelectedWhatsappMessage(msg);
                                                    setShowWhatsappModal(true);
                                                }}
                                            /> Edit

                                            <FaTrashAlt
                                                className='text-danger cursor-pointer'
                                                title="Delete"
                                                onClick={() => handleDeleteWhatsappMessage(msg._id)}
                                            /> Delete
                                        </div>
                                    </Td>
                                </Tr>
                            )) : (
                                <Tr><Td colSpan="3">No WhatsApp Messages</Td></Tr>
                            )}

                        </Tbody>
                    </Table>
                </TableContainer>

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={handleWhatsappPageChange}
                    pageRangeDisplayed={3}
                    pageCount={totalWhatsappPages}
                    previousLabel="< Previous"
                    className="pagination"
                />

            </div>

            {/* Modal for Add/Edit Lead Status */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? "Edit" : "Add"} Lead Status</Modal.Title>
                </Modal.Header>
                <Formik initialValues={{
                    title: selectedLeadStatus?.title || '',
                    backgroundColor: selectedLeadStatus?.backgroundColor || '#000000',
                }} validationSchema={validationSchema} onSubmit={handleAddOrUpdateLeadStatus} enableReinitialize>
                    {({ handleSubmit }) => (
                        <FormikForm onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Field type="text" name="title" className="form-control" placeholder="Enter title" />
                                    <ErrorMessage name="title" component="div" className="text-danger" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Background Color</Form.Label>
                                    <Field type="color" name="backgroundColor" className="form-control" />
                                    <ErrorMessage name="backgroundColor" component="div" className="text-danger" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                                <Button type="submit" className="!bg-theme-dark border-0">{isEditing ? "Update" : "Add"}</Button>
                            </Modal.Footer>
                        </FormikForm>
                    )}
                </Formik>
            </Modal>

            {/* Voice AI Status Modal */}
            <Modal show={showConfigurationModal} onHide={handleCloseConfigurationModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditingConfiguration ? "Edit" : "Add"} Voice AI Status</Modal.Title>
                </Modal.Header>
                <Formik initialValues={{
                    title: selectedConfigurationStatus?.title || '',
                    backgroundColor: selectedConfigurationStatus?.backgroundColor || '#000000',
                }} validationSchema={validationSchema} onSubmit={handleAddOrUpdateConfigurationStatus} enableReinitialize>
                    {({ handleSubmit }) => (
                        <FormikForm onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Field type="text" name="title" className="form-control" placeholder="Enter title" />
                                    <ErrorMessage name="title" component="div" className="text-danger" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Background Color</Form.Label>
                                    <Field type="color" name="backgroundColor" className="form-control" />
                                    <ErrorMessage name="backgroundColor" component="div" className="text-danger" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseConfigurationModal}>Close</Button>
                                <Button type="submit" className="!bg-theme-dark border-0">{isEditingConfiguration ? "Update" : "Add"}</Button>
                            </Modal.Footer>
                        </FormikForm>
                    )}
                </Formik>
            </Modal>

            {/* WhatsApp Modal */}
            <Modal show={showWhatsappModal} onHide={() => setShowWhatsappModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditingWhatsapp ? "Edit" : "Add"} WhatsApp Message</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        title: selectedWhatsappMessage?.title || '',
                        message: selectedWhatsappMessage?.description || '',
                    }}
                    validationSchema={whatsappValidationSchema}
                    onSubmit={handleAddOrUpdateWhatsapp}
                    enableReinitialize
                >
                    {({ handleSubmit }) => (
                        <FormikForm onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Field type="text" name="title" className="form-control" />
                                    <ErrorMessage name="title" component="div" className="text-danger" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Message</Form.Label>
                                    <Field as="textarea" name="message" className="form-control" rows={3} />
                                    <ErrorMessage name="message" component="div" className="text-danger" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowWhatsappModal(false)}>Close</Button>
                                <Button type="submit" className="!bg-theme-dark border-0">{isEditingWhatsapp ? "Update" : "Add"}</Button>
                            </Modal.Footer>
                        </FormikForm>
                    )}
                </Formik>
            </Modal>
            {/* Email Messages Section */}
            <div ref={emailRef} className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between'>
                    <h3 className='fw-bold'>Email Templates</h3>
                    <div className="flex items-center gap-3">
                        Rows per page:
                        <select value={emailRowsPerPage} onChange={handleEmailRowsChange} className="ms-2 border rounded-md focus:outline-none">
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    <Button className="!bg-theme-dark fw-bold d-flex align-items-center border-0" onClick={() => {
                        setIsEditingEmail(false);
                        setSelectedEmailTemplate(null);
                        setShowEmailModal(true);
                    }}>
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Email Template
                    </Button>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="blue">
                        <Thead>
                            <Tr>
                                <Th>Title</Th>
                                <Th>Message</Th>
                                <Th>Created By</Th>
                                <Th>Actions</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {getAllEmailTemplates?.data?.length > 0 ? getAllEmailTemplates?.data?.map((template) => (
                                <Tr key={template?._id}>
                                    <Td>{template?.title}</Td>
                                    <Td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{template?.description}</Td>
                                    <Td>{template?.createdBy?.name || '-'}</Td>
                                    <Td>
                                        <div className='d-flex gap-2 fs-6 fw-bold'>
                                            <FaEdit className='text-success' onClick={() => {
                                                setIsEditingEmail(true);
                                                setSelectedEmailTemplate(template);
                                                setShowEmailModal(true);
                                            }} /> Edit
                                            <FaTrashAlt className='text-danger cursor-pointer' title="Delete" onClick={() => handleDeleteEmailTemplate(template._id)} /> Delete
                                        </div>
                                    </Td>
                                </Tr>
                            )) : (
                                <Tr><Td colSpan="4">No Email Templates</Td></Tr>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={handleEmailPageChange}
                    pageRangeDisplayed={3}
                    pageCount={totalEmailPages}
                    previousLabel="< Previous"
                    className="pagination"
                />
            </div>
            {/* Email Modal */}
            <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditingEmail ? "Edit" : "Add"} Email Template</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        title: selectedEmailTemplate?.title || '',
                        message: selectedEmailTemplate?.description || '',
                    }}
                    validationSchema={emailValidationSchema}
                    onSubmit={handleAddOrUpdateEmail}
                    enableReinitialize
                >
                    {({ handleSubmit }) => (
                        <FormikForm onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Field type="text" name="title" className="form-control" />
                                    <ErrorMessage name="title" component="div" className="text-danger" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Message</Form.Label>
                                    <Field as="textarea" name="message" className="form-control" rows={3} />
                                    <ErrorMessage name="message" component="div" className="text-danger" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowEmailModal(false)}>Close</Button>
                                <Button type="submit" className="!bg-theme-dark border-0">{isEditingEmail ? "Update" : "Add"}</Button>
                            </Modal.Footer>
                        </FormikForm>
                    )}
                </Formik>
            </Modal>

            {/* Add this section before or after your existing sections */}
            <div className="mb-4 p-4 bg-white rounded-lg shadow">
                <div className="flex items-center justify-between">
                    <div>
                        <h3 className="text-lg font-bold">Auto Assign Leads</h3>
                        <p className="text-gray-600">Automatically assign leads to managers</p>
                    </div>
                    <Switch
                        isChecked={isAutoAssign}
                        onChange={handleAutoAssignToggle}
                        colorScheme="green"
                        size="lg"
                    />
                </div>
            </div>
            {/* Lead From Section */}
            <div ref={leadFromRef} className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between'>
                    <h3 className='fw-bold'>Lead From</h3>
                    <div>
                        Rows per page:
                        <select
                            value={leadFromRowsPerPage}
                            onChange={handleLeadFromRowsChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    <Button
                        className="!bg-theme-dark fw-bold d-flex align-items-center border-0"
                        onClick={() => {
                            setIsEditingLeadFrom(false);
                            setSelectedLeadFrom(null);
                            setShowLeadFromModal(true);
                        }}
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Lead From
                    </Button>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Title</Th>
                                <Th>Assigned Manager</Th>
                                <Th>Created By</Th>
                                <Th>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {getSettings?.getLeadFroms?.leadFroms?.length > 0 ? getSettings?.getLeadFroms?.leadFroms.map((leadFrom) => (
                                <Tr key={leadFrom._id}>
                                    <Td>{leadFrom.title}</Td>
                                    <Td>{leadFrom.leadAssignTo?.name || '-'}</Td>
                                    <Td>{leadFrom?.createdBy?.name || '-'}</Td>
                                    <Td>
                                        <div className='d-flex gap-2 fs-6 fw-bold'>
                                            <FaEdit
                                                className='text-success'
                                                onClick={() => {
                                                    setIsEditingLeadFrom(true);
                                                    setSelectedLeadFrom(leadFrom);
                                                    setShowLeadFromModal(true);
                                                }}
                                            /> Edit
                                            <FaTrashAlt
                                                className='text-danger cursor-pointer'
                                                onClick={() => handleDeleteLeadFrom(leadFrom._id)}
                                            /> Delete
                                        </div>
                                    </Td>
                                </Tr>
                            )) : (
                                <Tr><Td colSpan="4" className="text-center">No Lead From Found</Td></Tr>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={handleLeadFromPageChange}
                    pageRangeDisplayed={5}
                    pageCount={getSettings?.getLeadFroms?.totalPages || 1}
                    previousLabel="< Previous"
                    renderOnZeroPageCount={null}
                    className="pagination"
                />
            </div>

            {/* Lead From Modal */}
            <Modal show={showLeadFromModal} onHide={() => setShowLeadFromModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditingLeadFrom ? "Edit" : "Add"} Lead From</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        title: selectedLeadFrom?.title || '',
                        leadAssignTo: selectedLeadFrom?.leadAssignTo?._id || ''
                    }}
                    validationSchema={leadFromValidationSchema}
                    onSubmit={handleAddOrUpdateLeadFrom}
                    enableReinitialize
                >
                    {({ handleSubmit }) => (
                        <FormikForm onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Field
                                        type="text"
                                        name="title"
                                        className="form-control"
                                        placeholder="Enter title"
                                    />
                                    <ErrorMessage name="title" component="div" className="text-danger" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Assign Manager</Form.Label>
                                    <Field
                                        as="select"
                                        name="leadAssignTo"
                                        className="form-control"
                                    >
                                        <option value="">Select Manager</option>
                                        {managers?.map((manager) => (
                                            <option key={manager._id} value={manager._id}>
                                                {manager.name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="leadAssignTo" component="div" className="text-danger" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowLeadFromModal(false)}>
                                    Close
                                </Button>
                                <Button type="submit" className="!bg-theme-dark border-0">
                                    {isEditingLeadFrom ? "Update" : "Add"}
                                </Button>
                            </Modal.Footer>
                        </FormikForm>
                    )}
                </Formik>
            </Modal>
            {/*  Add this modal component in your return statement, after all other content */}
            <Modal show={showDeleteLeadFromModal} onHide={() => setShowDeleteLeadFromModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Lead From</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 className='text-center'>Are You Sure?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowDeleteLeadFromModal(false)}
                        className='px-4 bg-transparent border-[1px] text-black border-green-color'
                    >
                        No
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={confirmDeleteLeadFrom}
                        className="!bg-green-color border-0 px-4"
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
